import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedRoutingModule } from './shared-routing.module';
import { HomeComponent } from './home/home.component';
import { HttpModule } from '@angular/http';
import { DatePipe } from '@angular/common';
import { SharedService } from './shared.service';
import { AddressNotAvailableComponent } from './address-not-available/address-not-available.component';
import { FullyQaulifiedAddressComponent } from './fully-qaulified-address/fully-qaulified-address.component';
import { PipeModule } from './pipe/pipe.module';
import { HomeMsiteComponent } from './home-msite/home-msite.component';
import { ResetMobComponent } from './reset-mob/reset-mob.component';
import { EnrollComponent } from './enroll/enroll.component';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCheckboxModule,
  MatDialogModule,
  MatIconModule,
  MatInputModule,
  MatProgressSpinnerModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatProgressBarModule } from '@angular/material';
import {DataDogRumService} from '../datadog/DataDogRumService';
@NgModule({
schemas: [
    CUSTOM_ELEMENTS_SCHEMA
],
  imports: [
    CommonModule,
    SharedRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    PipeModule.forRoot(),
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatProgressBarModule
  ],
  providers: [SharedService, DatePipe, DataDogRumService],
  declarations: [
    AddressNotAvailableComponent,
    FullyQaulifiedAddressComponent,
    HomeComponent,
    HomeMsiteComponent,
    ResetMobComponent,
    EnrollComponent
    ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts